import { Component, OnInit } from '@angular/core';
import { NavigationConstant } from '@constant/navigation.constant';
import { Router } from '@angular/router';
import { paymentVaStorage } from '@shared/storage/payment-va.storage';

// noinspection JSIgnoredPromiseFromCall,DuplicatedCode
@Component({
  selector: 'app-payment-result-bsi-snap',
  templateUrl: './payment-result-bsi-snap.component.html'
})
export class PaymentResultBsiSnapComponent implements OnInit {
  imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/success.png';
  imagePath;
  moduleName;
  paymentResult = 'Success';
  isSuccess = true;
  failedReason;
  virtualAccountNo: number;
  virtualAccountName: string;
  transactionAmount: string;
  transactionAmountCurrency: string;

  constructor(
    private router: Router,
    private storage: paymentVaStorage,
  ) { }

  ngOnInit(): void {
    if (this.storage.paymentResult == null) {
      this.router.navigate([NavigationConstant.BSI_SNAP_INQUIRY]);
    }

    this.populateData();
    this.displayResult();
  }

  goToInquiry() {
    this.router.navigate([NavigationConstant.BSI_SNAP_INQUIRY]);
  }

  populateData() {
    this.imagePath = this.storage.imagePath;
    this.moduleName = this.storage.moduleName;
    this.virtualAccountNo = this.storage.data.virtualAccountNo;
    this.virtualAccountName = this.storage.inquiryResult.virtualAccountData.virtualAccountName;
    this.transactionAmount = this.storage.paymentResult.virtualAccountData?.paidAmount?.value || this.storage.data.amount;
    this.transactionAmountCurrency = this.storage.paymentResult.virtualAccountData?.paidAmount?.currency || 'IDR';
  }

  displayResult() {
    const responseCode = this.storage.paymentResult.responseCode;
    if (responseCode !== '2002500') {
      this.paymentResult = 'Failed';
      this.imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/fail.png';
      this.isSuccess = false;
      this.failedReason = this.storage.paymentResult.responseMessage || 'Undefined Error';
    }
  }
}
